/**
 * Category Service - 业务逻辑层 + Mock 适配
 * 页面组件只调用此 Service 层,不直接调用 API
 */

import { config } from '../../config';
import * as categoryMock from '../../mocks/master-data/category';
import httpClient from '../httpClient';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';
import type { ApiResponse, PageData } from '../../types/common';
import type {
  CategoryDTO,
  CategoryTreeNode,
  CategoryType,
  QueryCategoryPageRequest,
} from '../../types/master-data/category';

/**
 * 分页查询类目列表
 */
export async function pageCategory(
  params: QueryCategoryPageRequest
): Promise<ApiResponse<PageData<CategoryDTO>>> {
  if (config.mock) {
    return categoryMock.mockPageCategory(params);
  }

  return httpClient.post(API_ENDPOINTS.CATEGORY.PAGE, params);
}

/**
 * 查询类目树形结构
 * @param dimension 类目维度（GF / HY）
 */
export async function getCategoryTree(dimension?: 'GF' | 'HY'): Promise<ApiResponse<CategoryTreeNode[]>> {
  if (config.mock) {
    return categoryMock.mockGetCategoryTree(dimension);
  }

  return httpClient.get(API_ENDPOINTS.CATEGORY.TREE, { params: { dimension } });
}
